import request from '@/utils/http';
const API_COMMON = 'api-antms/common';
// const API_COMMON = '';

// 分页查询
export const queryByPage = (data) => {
    return request({
        url: `${API_COMMON}/print/template/config/query`,
        method: 'post',
        data
    });
};

// 配置明细查询
export const queryDetails = (data) => {
    return request({
        url: `${API_COMMON}/print/template/config/detail`,
        method: 'get',
        params: data
    });
};

// 新增接口
export const handleAdd = (data) => {
    return request({
        url: `${API_COMMON}/print/template/config/add`,
        method: 'post',
        data
    });
};

// 编辑接口
export const handleEdit = (data) => {
    return request({
        url: `${API_COMMON}/print/template/config/update`,
        method: 'post',
        data
    });
};

// 批量删除接口
export const handleDelete = (data) => {
    return request({
        url: `${API_COMMON}/print/template/config/delete`,
        method: 'post',
        data
    });
};

// 批量停用接口
export const handleDisable = (data) => {
    return request({
        url: `${API_COMMON}/print/template/config/disable`,
        method: 'post',
        data
    });
};

// 批量启用接口
export const handleEnable = (data) => {
    return request({
        url: `${API_COMMON}/print/template/config/enable`,
        method: 'post',
        data
    });
};

// 预览打印接口
export const handlePreview = (data) => {
    return request({
        url: `/api-antms/transport/print/dispatch/preview`,
        method: 'post',
        data
    });
};

// 更新打印次数
export const updatePrintCount = data => {
    return request({
        url: `/api-antms/transport/print/dispatch/updateTimes`,
        method: 'post',
        data
    });
};
